import type { OrderType } from "@/types";
import OrderListTable from "@univdiam/ui/customComponents/OrderList/OrderListTable"
import type { TableViewProps } from "@univdiam/ui/lib/SharedTypes";

import { useEffect, useState } from "react";

const TableView = ({
  data,
  handleOrderOpen,
  globalFilter,
  setGlobalFilter,
  sorting,
  setSorting,
  columnVisibility,
  setColumnVisibility,
  onUpdateOrder,
  adminTags,
  fetchTags,
  page,
  setPage,
  pagination
}: TableViewProps & { page?: number, setPage?: any, pagination?: any }) => {
  const [cards, setCards] = useState<OrderType[]>([]);
  useEffect(() => {
    if (!data) {
      setCards([]);
      return;
    }

    // No client-side tag filtering: the API filters by label now, so `data` is
    // already the matching set.
    const transformed = data.map(order => ({
      ...order,
      column: order.status
    }));
    setCards(transformed);
  }, [data])
  return (
    <div className="min-h-screen w-full">
      <OrderListTable
        data={cards}
        handleOrderOpen={handleOrderOpen}
        isAdmin={true}
        onUpdateOrder={onUpdateOrder}
        adminTags={adminTags}
        fetchTags={fetchTags}
        page={page}
        setPage={setPage}
        pagination={pagination}
        {...{ globalFilter, setGlobalFilter, sorting, setSorting, columnVisibility, setColumnVisibility }}
      />
    </div>
  )
}

export default TableView